var Codec = require('io/codec');

var serialiser = {
    read : function(input) {
        return Codec.readByte(input) === 1;
    },
    write : function(output, val) {
        Codec.writeByte(output, val ? 1 : 0);
    }
};

module.exports = serialiser;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/serialisers/boolean-serialiser.js
// module id = 999
// module chunks = 1